import "./index.css";
const bookList = require("./csvjson.json");
import React, { useState } from "react";

// TODO
// - Amazon link ✅
// - Search ✅
// - Sorting ✅
// - Switch between sort by Title/Artist
// - Chips to sort by genre
// - Remove expanding header ✅
// - Update json ✅
// - Make amazon links open in new tab ✅
// - Put frame in sandbox?

export function App() {

    // Search
  let [searchTitleText, setSearchTitleText] = useState("");
  let [searchAuthorText, setSearchAuthorText] = useState("");
  let [searchHeritageText, setSearchHeritageText] = useState("");
  let [searchGenreText, setSearchGenreText] = useState("");

  const books = bookList
    .filter((book: any) =>
      book.title.toLowerCase().includes(searchTitleText.toLowerCase())
    )
    .filter((book: any) =>
      book.authorName.toLowerCase().includes(searchAuthorText.toLowerCase())
    )
    .filter((book: any) =>
      book.heritage.toLowerCase().includes(searchHeritageText.toLowerCase())
    )
    .filter((book: any) =>
      book.genres.toLowerCase().includes(searchGenreText.toLowerCase())
    )
    // Alphabetical sort by title
    .sort((a: any, b: any) => a.title.localeCompare(b.title));

    function scrollToTop() {
    window.scrollTo(0, 0);
  }

  // Indivisual Card
  const listItems = books.map((book: any) => (
    <li key={book.id}>
      <div className="Card">
        <a
          target="_blank"
          href={
            "https://www.amazon.co.uk/s?k=" +
            book.title.replace("&", "%26") +
            " " +
            book.authorName
          }
        >
          <h2>{book.title}</h2>
        </a>
        <img
          src={`${book.coverURL}`}
          alt="Book cover"
        />
        <p>Author: {book.authorName}</p>
        <p>Heritage: {book.heritage}</p>
        <p>Publisher: {book.publisher}</p>
        <p>Publication Date: {book.publicationDate}</p>
        <p>ISBN: {book.isbn}</p>
        <p>Genre/s: {book.genres}</p>
      </div>
    </li>
  ));

  return (
    <>
      <center>
        <p className="title">Black British Booklist</p>

        <input
          className="searchBox"
          value={searchTitleText}
          placeholder="Search by title"
          onChange={(e) => setSearchTitleText(e.target.value)}
        />
        <input
          className="searchBox"
          value={searchAuthorText}
          placeholder="Search by author"
          onChange={(e) => setSearchAuthorText(e.target.value)}
        />
        <input
          className="searchBox"
          value={searchHeritageText}
          placeholder="Search by heritage"
          onChange={(e) => setSearchHeritageText(e.target.value)}
        />
        <input
          className="searchBox"
          value={searchGenreText}
          placeholder="Search by genre"
          onChange={(e) => setSearchGenreText(e.target.value)}
        />
        <ul>{listItems}</ul>
        <button onClick={() => scrollToTop()}>Back to top</button>
      </center>
    </>
  );
}

export default App;
